module.exports = __webpack_public_path__ + "img/certificated.d576dde3.svg";